module.exports = __webpack_public_path__ + "static/media/2.3ac6456a.png";